import React, { Fragment, useEffect, useState } from "react";
import { XIcon } from "@heroicons/react/outline";
import { ResetIcon } from "../../../../assets/icons";
import DropDownComponent from "../../questions/metadataDropDownList";
import Loader from "../../../shared/loader/loader";
import { getLiftOffGalaxyStandard } from "../../../../api/liftOffGalaxyStandard.service";
import { checkQuestionExists } from "../../../../api/liftOffDiagnosticTestQuestion.service";
import { IDropDown } from "../../../../model/shared/dropDown";
import { ILiftOffGalaxyTopic } from "../../../../model/interface/liftOffGalaxyStandard";
import {
  ILiftOffDiagnosticTest,
  ILiftOffDiagnosticTestQuestion,
  ILiftOffDiagnosticTestQuestionDTO,
  IQuestionExistsRequest,
} from "../../../../model/interface/liftOffDiagnosticTest";
import { connect } from "react-redux";
import { getGradeByStandardId } from "../../../../api/grade.service";
import { toast } from "react-toastify";

interface StandardTestPopupProps {
  liftOffHeaderId: number;
  subjectId: number;
  testName: string;
  profile: any;
  editFlag: boolean;
  loDiagnosticTestQuestions: Array<ILiftOffDiagnosticTestQuestionDTO>;
  liftOffDiagnosticTestID: number;
  showPopup: (show: boolean) => void;
  saveTest: (data: any) => void;
}

const StandardTestPopup = (props: StandardTestPopupProps) => {
  const defaultPageNumber = 1;
  const defaultPageSize = 9999999;
  const [loading, setLoading] = useState<boolean>(false);
  const [galaxyStandards, setGalaxyStandards] = useState<Array<IDropDown>>([]);
  const [grades, setGrades] = useState<Array<IDropDown>>([]);
  const [selectedStandardId, setStandardId] = useState(0);
  const [selectedGradeId, setGradeId] = useState(0);
  const [selectedTestName, setTestName] = useState("");
  const [selectedQuestionId1, setQuestionId1] = useState(0);
  const [selectedQuestionId2, setQuestionId2] = useState(0);
  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const [allGalaxyStandards, setAllGalaxyStandards] = useState<
    Array<ILiftOffGalaxyTopic>
  >([]);

  useEffect(() => {
    bindLFGalaxyStandardData();
    bindData();
  }, [props.liftOffHeaderId]);

  const bindLFGalaxyStandardData = () => {
    async function lfGalaxyStandardReload() {
      setLoading(true);
      const response = getLiftOffGalaxyStandard(
        props.liftOffHeaderId,
        0,
        false,
        defaultPageNumber,
        defaultPageSize
      );

      const data = await response;
      setAllGalaxyStandards(data.data.data);
      const lfGalaxyStandardDDLData = data.data.data.map(
        (values: ILiftOffGalaxyTopic) => {
          return {
            label: values?.code + " " + values?.standardName,
            value: values?.standardId,
          };
        }
      );
      if (lfGalaxyStandardDDLData.length === 0) {
        toast.error("Please add new galaxy and add standards to it");
      }
      setGalaxyStandards(lfGalaxyStandardDDLData);
      setLoading(false);
    }
    lfGalaxyStandardReload();
  };

  const bindData = () => {
    setTestName(props.testName);
  };

  const getGradeByStandard = (standardId: number) => {
    setLoading(true);
    getGradeByStandardId(standardId)
      .then((r) => {
        const gradeData = r.data?.map((grade) => {
          return {
            value: grade.gradeId,
            label: grade.name,
          };
        });

        setGrades(gradeData);
        setLoading(false);
      })
      .catch((r) => {
        setLoading(false);
      });
  };

  const handleLFStandardChange = (standardId: any) => {
    setStandardId(standardId);
    getGradeByStandard(standardId);
  };

  const handleGradeChange = (gradeId: any) => {
    setGradeId(gradeId);
  };

  const handleTestNameChange = (name: string) => {
    setTestName(name);
  };

  const handleQuestionId1Change = (questionId: number) => {
    setQuestionId1(questionId);
  };

  const handleQuestionId2Change = (questionId: number) => {
    setQuestionId2(questionId);
  };

  const validateData = (question: ILiftOffDiagnosticTestQuestion) => {
    let isValid = true;

    if (galaxyStandards.length === 0) {
      toast.error("Please add new galaxy and add standards to it");
      isValid = false;
    } else if (question.questionId1 === 0 || question.questionId2 === 0) {
      toast.error("QuestionId is required");
      isValid = false;
    } else if (question.standardReferenceId === 0) {
      toast.error("StandardId is required");
      isValid = false;
    } else if (question.gradeId === 0) {
      toast.error("GradeId is required");
      isValid = false;
    }
    return isValid;
  };

  const handleSaveTest = async () => {
    const test: ILiftOffDiagnosticTest = {
      liftOffDiagnosticTestId: props.liftOffDiagnosticTestID,
      name: selectedTestName,
      liftOffHeaderId: props.liftOffHeaderId,
      subjectId: props.subjectId,
      isActive: true,
      createdByUserId: props.profile?.userId,
    };

    const question: ILiftOffDiagnosticTestQuestion = {
      liftOffDiagTestQuestionId: 0,
      liftOffDiagnosticTestID: props.liftOffDiagnosticTestID,
      standardReferenceId: selectedStandardId,
      isStandardGroup: false,
      gradeId: selectedGradeId,
      questionId1: selectedQuestionId1,
      questionId2: selectedQuestionId2,
      orderNumber: props.loDiagnosticTestQuestions.length + 1,
      isActive: true,
      createdByUserId: props.profile?.userId,
    };

    const data: any = {
      test: test,
      questions: [question],
    };

    if (validateData(question)) {
      const request: IQuestionExistsRequest = {
        liftOffDiagnosticTestId: props.liftOffDiagnosticTestID,
        standardReferenceId: selectedStandardId,
        isStandardGroup: question.isStandardGroup,
        gradeId: selectedGradeId,
        questionId1: selectedQuestionId1,
        questionId2: selectedQuestionId2,
      };
      checkQuestionExists(request).then((r) => {
        const response = r.data;

        if (
          !response.questionId1PresentInStandard ||
          !response.questionId2PresentInStandard
        ) {
          toast.error(
            "Question does not exist or Question does not belong to this Standard"
          );
        } else if (
          response.questionId1PresentInTest ||
          response.questionId2PresentInTest
        ) {
          toast.error("Duplicate questionId is not allowed");
        } else {
          props.saveTest(data);
          handleResetFilter();
          props.showPopup(false);
        }
      });
    }
  };

  const handleResetFilter = () => {
    setGrades([]);
    setResetDropdownFlag(true);
    setQuestionId1(0);
    setQuestionId2(0);
  };

  return (
    <Fragment>
      {loading && <Loader />}
      <div className="fixed z-10 inset-0 overflow-y-auto">
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen">
            &#8203;
          </span>
          <div className="inline-block w-full align-bottom bg-white px-4 pt-5 pb-8 text-left  shadow-xl transform transition-all sm:align-middle sm:max-w-[80%] sm:w-full sm:p-6">
            <div className=" flex justify-end">
              <button
                onClick={() => props.showPopup(false)}
                type="button"
                className="bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
              >
                <XIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className={"pt-6 border-b pb-6"}>
              <div className="grid sm:grid-cols-4 md:grid-cols-8  xl:grid-cols-12 gap-6 text-sm">
                <div className="col-span-4">
                  <div className={"self-center place-self-srt col-span-2"}>
                    Test Name
                  </div>
                  <div className={"w-full mt-1"}>
                    <input
                      className="shadow appearance-none border border-gray-300 rounded-sm shadow-md w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      type="text"
                      value={selectedTestName}
                      onChange={(e) => {
                        handleTestNameChange(e.target.value);
                      }}
                    ></input>
                  </div>
                </div>
                <div className="col-span-4">
                  <div className={"self-center place-self-srt col-span-2"}>
                    Standard
                  </div>
                  <div className={"w-full mt-1"}>
                    <DropDownComponent
                      dropName={"Standards"}
                      dropValue={galaxyStandards}
                      resetDropdown={resetDropdownFlag}
                      defaultValue={"Select Standard"}
                      dropSelect={handleLFStandardChange}
                      disabled={false}
                    ></DropDownComponent>
                  </div>
                </div>
                <div className="col-span-4">
                  <div className={"self-center place-self-srt col-span-2"}>
                    Grade
                  </div>
                  <div className={"w-full mt-1"}>
                    <DropDownComponent
                      dropName={"Grades"}
                      dropValue={grades}
                      resetDropdown={resetDropdownFlag}
                      defaultValue={"Select Grade"}
                      dropSelect={handleGradeChange}
                      disabled={false}
                    ></DropDownComponent>
                  </div>
                </div>
                <div className="col-span-4">
                  <div className={"self-center place-self-srt col-span-2"}>
                    QuestionId 1
                  </div>
                  <div className={"w-full mt-1"}>
                    <input
                      className="shadow appearance-none border border-gray-300 rounded-sm shadow-md w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      type="number"
                      value={selectedQuestionId1}
                      onChange={(e) => {
                        handleQuestionId1Change(parseInt(e.target.value));
                      }}
                    ></input>
                  </div>
                </div>
                <div className="col-span-4">
                  <div className={"self-center place-self-srt col-span-2"}>
                    QuestionId 2
                  </div>
                  <div className={"w-full mt-1"}>
                    <input
                      className="shadow appearance-none border border-gray-300 rounded-sm shadow-md w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      type="number"
                      value={selectedQuestionId2}
                      onChange={(e) => {
                        handleQuestionId2Change(parseInt(e.target.value));
                      }}
                    ></input>
                  </div>
                </div>
              </div>

              <div className="float-right mt-4">
                <button
                  className="mt-4 inline-flex items-center text-sm text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                  type="button"
                  onClick={() => {
                    handleSaveTest();
                  }}
                >
                  {props.editFlag ? "Edit Question" : "Add Question"}
                </button>
                <button
                  type="button"
                  className="hidden mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                  onClick={() => {
                    handleResetFilter();
                  }}
                >
                  <ResetIcon className="w-3 h-3"></ResetIcon>
                  <span>Reset Filter</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(StandardTestPopup);
